import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import InfoSection from '../InfoSection/InfoSection';
import PBISection from '../PBISection/PBISection';
import { selectVCardPBIState } from '../../selectors/vcard.selector'

const TabsSection = props => {
  const { info, groupId, isLoading, style, isPlaying, changePlay } = props;
  const userHasSession = useSelector(state => state.user.userhash);
  const [tabs, changeTabIndex] = useState({ currentTab: 0, prevTab: 0 });
  const { infoPBI } = useSelector(selectVCardPBIState);

  useEffect(
    () => {
      changeTabIndex({ currentTab: 0, prevTab: 0 });
    },
    [groupId],
  );

  const { currentTab, prevTab } = tabs;

  return (
    <>
      <div className="fadeInRight">
        <div className="VCard__content">
          <div
            className={`VCard__content__info  row col-md-11 col-xs-12 col-lg-6 col-xl-6  ${
              isPlaying ? 'playing' : ''
            }`}
            style={{...style, padding: 0}}
          >
            <InfoSection
              className="col-xs-12"
              data={info}
              id={groupId}
              isLoading={isLoading}
              changePlay={changePlay}
              isPlaying={isPlaying}
            />
          </div>
          <PBISection
            groupId={groupId}
            isLoading={isLoading}
            changePlay={changePlay}
            isPlaying={isPlaying}
            userHasSession={userHasSession}
          />
        </div>
      </div>
    </>
  );
};

TabsSection.propTypes = {
  info: PropTypes.shape({
    isSerie: PropTypes.bool,
    episode: PropTypes.shape({}),
    hasPreview: PropTypes.bool,
  }),
  style: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  groupId: PropTypes.string,
};

TabsSection.defaultProps = {
  info: {},
  style: {},
  isLoading: false,
};

export default TabsSection;
